// extracted by mini-css-extract-plugin
export default {"item":"Tabs_item__TOjmg","container":"Tabs_container__nrUCi","content":"Tabs_content__i78qz","active":"Tabs_active__thqCe"};